/// <amd-module name="RMWidgets/DeploymentStatusWidget/Clients/RestClient/TestResults" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   releasemanagement\web\extensions\release\vss-releasemanagement-web\widgets\deployment-status-widget\clients\test.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Test from "RMWidgets/DeploymentStatusWidget/Clients/Contracts/Test";

export interface ITestResultsRestClient extends IVssRestClient {
    /**
     * @param releases - 
     * @param project - Project ID or project name
     */
    queryTestResultsSummaryForReleases(releases: Test.ReleaseReference[], project: string): Promise<Test.TestResultSummary[]>;
}

class TestResultsRestClient extends RestClientBase implements ITestResultsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param releases - 
     * @param project - Project ID or project name
     */
    public async queryTestResultsSummaryForReleases(
        releases: Test.ReleaseReference[],
        project: string
        ): Promise<Test.TestResultSummary[]> {

        return this.beginRequest<Test.TestResultSummary[]>({
            apiVersion: "5.2-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/testresults/resultsummarybyrelease",
            routeValues: {
                project: project
            },
            body: releases
        });
    }

}

export const TestResultsClientName = "dsw.testresults.client.ITestResultsRestClient";

export function getTestResultsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITestResultsRestClient {
    return pageContext.getRestClient<ITestResultsRestClient>(TestResultsClientName, options);
}

RestClients.add(TestResultsClientName, { 
    factory: TestResultsRestClient,
    options: {
        resourceAreaId: "c83eaf52-edf3-4034-ae11-17d38f25404c",
        serviceInstanceType: "00000054-0000-8888-8000-000000000000"
    }
});
